import { useIntl } from 'react-intl';
import { SimpleGrid } from '@chakra-ui/react';
import ComboboxFormikField from 'components/forms/ComboboxFormikField';

const PeakPeriodTab = ({ options }) => {
    const intl = useIntl();

    return (
        <SimpleGrid spacingX={6} spacingY={5} columns={3}>
            <ComboboxFormikField
                id="onPeakPeriodId"
                name="onPeakPeriodId"
                label={intl.formatMessage({ id: 'basis_tabs_on_peak' })}
                options={options.peakPeriods}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="offPeakPeriodId"
                name="offPeakPeriodId"
                label={intl.formatMessage({ id: 'basis_tabs_off_peak' })}
                options={options.peakPeriods}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="atcPeriodId"
                name="atcPeriodId"
                label={intl.formatMessage({ id: 'basis_tabs_atc_peak' })}
                options={options.peakPeriods}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
        </SimpleGrid>
    );
};

export default PeakPeriodTab;
